import { render, staticRenderFns } from "./kanban.vue?vue&type=template&id=55339966&"
import script from "./kanban.vue?vue&type=script&lang=ts&"
export * from "./kanban.vue?vue&type=script&lang=ts&"
import style0 from "./kanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports